var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVoid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-x-02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M11.6693 9.16602H6.66927M8.33594 12.4993H6.66927M13.3359 5.83268H6.66927M16.6693 9.99935V5.66602C16.6693 4.26588 16.6693 3.56582 16.3968 3.03104C16.1571 2.56063 15.7747 2.17818 15.3042 1.9385C14.7695 1.66602 14.0694 1.66602 12.6693 1.66602H7.33594C5.93581 1.66602 5.23574 1.66602 4.70096 1.9385C4.23056 2.17818 3.8481 2.56063 3.60842 3.03104C3.33594 3.56582 3.33594 4.26588 3.33594 5.66602V14.3327C3.33594 15.7328 3.33594 16.4329 3.60842 16.9677C3.8481 17.4381 4.23056 17.8205 4.70096 18.0602C5.23574 18.3327 5.93581 18.3327 7.33594 18.3327H10.0026M13.3359 13.3327L17.5026 17.4993M17.5026 13.3327L13.3359 17.4993",
    stroke: "#667085",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoid);
export default __webpack_public_path__ + "static/media/void.e21a5cafbb8a0fdc279f30c9c36907e9.svg";
export { ForwardRef as ReactComponent };